// src/services/clinicQueueApi.js
// Front-desk queue endpoints — docs/visit-workflow-contract.md, "Queue — BE-4".
// api's baseURL already ends in /api.
import api from './api';

// A queue refresh runs every 30s; don't let one stalled call hang forever.
const LOAD = { timeout: 15000 };

export const clinicQueueAPI = {
  // GET /api/clinic/queue?date=YYYY-MM-DD&doctorId= -> QueueEntry[]
  list: ({ date, doctorId } = {}) =>
    api.get('/clinic/queue', {
      params: { ...(date && { date }), ...(doctorId && { doctorId }) },
      ...LOAD,
    }),

  // POST /api/clinic/queue/check-in {appointmentId} -> QueueEntry (409 if already arrived/closed)
  checkIn: (appointmentId) => api.post('/clinic/queue/check-in', { appointmentId }),

  // POST /api/clinic/queue/start-consultation {appointmentId} -> QueueEntry (ARRIVED -> IN_CONSULTATION; 409 otherwise)
  startConsultation: (appointmentId) => api.post('/clinic/queue/start-consultation', { appointmentId }),

  // POST /api/clinic/queue/walk-in {patientId, doctorId, reason?} -> QueueEntry
  walkIn: ({ patientId, doctorId, reason }) =>
    api.post('/clinic/queue/walk-in', { patientId, doctorId, ...(reason && { reason }) }),
};

export default clinicQueueAPI;
